export default {"src":"/_next/static/media/ChooseIocn4.857dd113.svg","height":56,"width":51};